module.exports = __webpack_public_path__ + "static/media/app-bar-save.64f30769.svg";